module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-table', {
    attrs: {
      "data": _vm.tableDataSimple,
      "opened-detailed": _vm.defaultOpenedDetails,
      "detailed": "",
      "detail-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "label": "ID",
            "width": "40",
            "numeric": ""
          }
        }, [_vm._v("\n            " + _vm._s(props.row.id) + "\n        ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "First Name"
          }
        }, [_vm._v("\n            " + _vm._s(props.row.first_name) + "\n        ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Last Name"
          }
        }, [_vm._v("\n            " + _vm._s(props.row.last_name) + "\n        ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Date",
            "centered": ""
          }
        }, [_vm._v("\n            " + _vm._s(new Date(props.row.date).toLocaleDateString()) + "\n        ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Gender"
          }
        }, [_vm._v("\n            " + _vm._s(props.row.gender) + "\n        ")])]
      }
    }, {
      key: "detail",
      fn: function(props) {
        return [_c('article', {
          staticClass: "media"
        }, [_c('figure', {
          staticClass: "media-left"
        }, [_c('p', {
          staticClass: "image is-64x64"
        }, [_c('img', {
          attrs: {
            "src": "static/img/placeholder-128x128.png"
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "media-content"
        }, [_c('div', {
          staticClass: "content"
        }, [_c('p', [_c('strong', [_vm._v(_vm._s(props.row.first_name) + " " + _vm._s(props.row.last_name))]), _vm._v(" "), _c('small', [_vm._v("@" + _vm._s(props.row.first_name))]), _vm._v(" "), _c('small', [_vm._v("31m")]), _vm._v(" "), _c('br'), _vm._v("\n                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n                        Proin ornare magna eros, eu pellentesque tortor vestibulum ut.\n                        Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis.\n                    ")])])])])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7291a16","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table.vue
// module id = 522
// module chunks = 1